export default {
  "seo.title": "About Us | Bonvi",
  "seo.description": "Meet the people, experience, and creative disciplines behind Bonvi.",
  "number.title": "Our Number",
  "number.copy": "Our team works across disciplines, allowing every project to bring together the right combination of skills.",
  "number.years": "Years of experience",
  "number.projects": "Projects delivered",
  "number.markets": "Markets reached",
  "strategy.title": "Our Strategy",
  "strategy.copy": "Bonvi scales creative by combining AI-powered operations with Southeast Asia's diverse creative workforce, giving ambitious brands greater speed, cultural depth, and performance impact without the overhead of building a large in-house team.",
  "strategy.ariaLabel": "Our strategy principles",
  "strategy.core.creative": "Creative",
  "strategy.core.growthAt": "growth at",
  "strategy.core.scale": "scale",
  "strategy.ai": "AI-Powered Creative Engine",
  "strategy.sea": "SEA Talent Network",
  "strategy.global": "Global Localization",
  "strategy.embedded": "Embedded Teams",
  "strategy.human": "Human Creative Direction",
  "strategy.performance": "Performance Creative",
  "creative.title": "Our Creative",
  "creative.copy1": "Our team works across disciplines, allowing every project to bring together the right combination of skills.",
  "creative.copy2": "We don't believe in one-size-fits-all creativity. Every project is shaped by its audience, platform, and purpose, combining strategic thinking with visual experimentation to create work that feels distinctive, relevant, and built for impact.",
  "creative.ariaLabel": "Our creative principles",
  "creative.idea": "Idea First",
  "creative.medium": "Made for the Medium",
  "creative.motion": "Motion in Our DNA",
  "creative.performance": "Creativity That Performs",
} as const;
